
const url = 'dashboard-report';

export const dashboardRoutes = {
  list: `/admin/${url}`,
};
